(ns teamoesterreich.core

  (:require
    [clojure.string :as str]
    [goog.object :as g]
    [reagent-material-ui.components :as mui]
    [reagent.core :as r]
    [reagent.dom :as rd]
    [teamoesterreich.admin-mode.actions :as adm-a]
    [teamoesterreich.admin-mode.admin-mode-core :as admin-mode]
    [teamoesterreich.setup :as setup]
    [teamoesterreich.util.log :as log]
    [teamoesterreich.view-state :as v-state]
    [teamoesterreich.view-state :as vstate]
    [teamoesterreich.web-path :as web-path]
    ["react-oidc-context" :as roc]
    ["jwt-decode" :as jwt]
    ["react" :as react]
    )

  (:import (goog.i18n DateTimeSymbols_de_AT)))

(def setup setup/config)

(def oidc-config
  (let [{keycloak-url       :keycloak-url
         client-url         :client-url
         keycloak-client-id :keycloak-client-id} setup
        keycloak-url (if (str/ends-with? keycloak-url "/") keycloak-url (str keycloak-url "/"))
        client-url (if (str/ends-with? client-url "/") client-url (str client-url "/"))
        ]
    {"authority"    keycloak-url
     "client_id"    keycloak-client-id
     "redirect_uri" (str client-url "login/callback")
     }))

;(js/console.log " SETUP " (clj->js setup))

(defn strip-prefix [s prefix]
  (if (str/starts-with? s prefix)
    (subs s (count prefix))
    s))

(defn load-page-from-path [path-with-fragment]
  (let [fragment (or (get (str/split (or path-with-fragment "") #"#" 2) 1) "")
        [entity param1 param2 param3] (.split fragment "$")
        entity (strip-prefix entity ":")
        entity (when (> (count entity) 0) (keyword entity))]
    (log/debug "set-web-path-page-fn called " path-with-fragment fragment entity param1 param2 param3)
    (when entity
      (adm-a/set-page-by-path entity param1 param2 param3))
    :ok))

(web-path/register load-page-from-path)

(defn sign-in [auth]
  (.setItem js/sessionStorage "toe.login-redirect" (web-path/get-token))
  (.signinRedirect auth))

(def !triedLogin (r/atom false))

(defn main [{:keys [navigator state data]}]
  (react/useEffect (fn []
                     (when (:error data)
                       (js/console.error (:source data) (:error data))

                       (when (= (:source data) "renewSilent")
                         (.removeUser (:auth data)))))
                   #js[(:source data) (:error data)])

  (case navigator
    "signinSilent" [:div "Login in Arbeit..."]
    "signoutRedirect" [:div "Logout in Arbeit..."]
    ;else
    (case state
      :loading [:div "Lade ..."]
      :error [:div (str "Fehler (" (:name data) "): " (:message data))]
      :authenticated [:<>
                      [mui/css-baseline]
                      [(admin-mode/main)]]
      :missing-role [:div [:button {:on-click (:on-sign-out data)} "Ausloggen"] [:span "Fehlende Berechtigung"]]
      ;else :unauthenticated
      (do
        (when (and (not @!triedLogin) (not (roc/hasAuthParams)))
          (js/console.log "trying login")
          ((:on-sign-in data))
          (reset! !triedLogin true))
        [:button {:on-click (:on-sign-in data)} "Einloggen"])
      )))

(defn main-with-auth []
  (let [this (r/current-component)
        {^js auth :auth} (r/props this)
        ;_ (js/console.log "auth" auth)
        user (.-user auth)
        access-token (try
                       (if user
                         (jwt/jwtDecode (.-access_token user))
                         nil)
                       (catch js/Error e
                         (js/console.log e)
                         nil))
        ;_ (js/console.log "access-token" access-token)
        admin-roles (g/getValueByKeys access-token "resource_access" "toe-admin" "roles")
        state (cond
                (.-isLoading auth) :loading
                (.-error auth) (cond
                                 (.-isAuthenticated auth) :error
                                 (and (= (.. auth -error -source) "renewSilent")
                                      (= (.. auth -error -name) "ErrorResponse")) :unauthenticated
                                 :else :error)
                (.-isAuthenticated auth) (if (some #(= % "toe-admin") admin-roles)
                                           (do
                                             ; (js/console.log "user" user)
                                             (reset! v-state/auth-state user)
                                             :authenticated)
                                           :missing-role)
                :else :unauthenticated)
        data (case state
               :error {:name    (.. auth -error -name)
                       :source  (.. auth -error -source)
                       :message (.. auth -error -message)
                       :error   (.. auth -error -innerError)
                       :auth    auth}
               :unauthenticated {:on-sign-in #(sign-in auth)}
               :missing-role {:on-sign-out #(.signoutRedirect auth)}
               nil)]
    [:f> main {:navigator (.-activeNavigator auth)
               :state     state
               :data      data}]))

(defn main-with-auth-provider []
  [:> roc/AuthProvider
   (merge oidc-config {
                       "onSigninCallback" (fn [user]
                                            ; (js/console.log "user" user)
                                            (reset! v-state/auth-state user)
                                            (.replaceState js/history {} "TÖ Admin Interface" "/")
                                            (when-let [login-redirect (.getItem js/sessionStorage "toe.login-redirect")]
                                              (.removeItem js/sessionStorage "toe.login-redirect")
                                              (load-page-from-path login-redirect)))
                       "onRemoveUser"     (fn []
                                            (reset! v-state/auth-state nil)
                                            (.pushState js/history {} "" "/"))
                       })
   [(r/adapt-react-class (roc/withAuth (r/reactify-component main-with-auth)))]])


(defn error-boundary [comp]
  (r/create-class
    {:constructor                  (fn [this props]
                                     (set! (.-state this) #js {:error nil}))
     :component-did-catch          (fn [this e info])
     :get-derived-state-from-error (fn [error] #js {:error error})
     :render                       (fn [this]
                                     (r/as-element
                                       (if-let [error (.. this -state -error)]
                                         [:div
                                          "Something went wrong."
                                          [:pre
                                           (str (.-message error) "\n" (.-stack error))]
                                          ]
                                         comp)))}))

(defn start []
  (vstate/get-texts)
  (vstate/get-translations)
  (set! (. js/document -title) "TÖ Admin Interface")
  (rd/render [error-boundary [main-with-auth-provider]] (js/document.getElementById "app")))


(start)
